import { ArrowDown2 } from 'iconsax-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import {
  OPERATOR_LABEL_MAPPER,
  OPERATORS_ACC_TO_FILTER_TYPE,
} from '../../entities-filters/config';
import { cn } from '@src/design-system/helpers';
import { inputVariants } from '@src/design-system/input';

import type { TField } from '@shared/types/field';
import type { OPERATORS } from '@shared/types/dynamic-filter';
import type { ValueOf } from '@shared/types/utilities';
import type { TCustomFieldFilter } from '@shared/types/custom-field-filter';
import customFieldFilterApi from '@shared/features/views/services/custom-field-filter-api';

const getOperatorLabel = (operatorValue: ValueOf<typeof OPERATORS>) => {
  return OPERATOR_LABEL_MAPPER[operatorValue];
};

export const DynamicCustomFieldOperatorDropdown = ({
  dynamicField,
  questionType,
  currentOperator,
  onChange,
}: {
  dynamicField: TCustomFieldFilter;
  currentOperator: TCustomFieldFilter['operator'];
  onChange?: (op: TCustomFieldFilter['operator']) => void;
  questionType: TField['type'];
}) => {
  const { mutate: editCustomFieldFilter } = customFieldFilterApi.useUpdate();

  const operatorLabel = getOperatorLabel(currentOperator!);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'w-full text-sm relative cursor-pointer items-center max-w-[150px]',
          inputVariants({ size: 'sm' })
        )}
      >
        <span className='w-[85%] text-start truncate'>{operatorLabel}</span>
        <ArrowDown2
          size={16}
          className='text-primary-1000 absolute right-2 top-1/2 -translate-y-1/2'
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        {OPERATORS_ACC_TO_FILTER_TYPE[questionType].map((op) => {
          const operatorLabel = getOperatorLabel(op);
          return (
            <DropdownMenuItem
              key={op}
              onClick={() => {
                if (dynamicField?.id) {
                  editCustomFieldFilter?.({
                    id: dynamicField?.id,
                    type: dynamicField.custom_field?.type,
                    custom_field: dynamicField.custom_field?.id,
                    operator: op,
                  });
                }

                onChange?.(op);
              }}
            >
              {operatorLabel}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
